import { BaseEditor, BasePoint, Editor, Transforms } from "slate";
import { HistoryEditor } from "slate-history";
import type { ReactEditor } from "slate-react";

const resetEditor = (editor: ReactEditor & BaseEditor & HistoryEditor) => {
  const point: BasePoint = { offset: 0, path: [0, 0] };

  editor.selection = { anchor: point, focus: point };
  editor.history = { redos: [], undos: [] };

  Transforms.delete(editor, {
    at: {
      anchor: Editor.start(editor, []),
      focus: Editor.end(editor, []),
    },
  });
  Transforms.removeNodes(editor, {
    at: [0],
  });
};

export default resetEditor;
